import store from "@/store/store.js";
import Vue from "vue";
import Router from "vue-router";
import Sites from "./views/Sites.vue";
import Catalogs_groups from "./views/Catalogs_groups.vue";
import PaymentsOnlyMonth from "./views/PaymentsOnlyMonth.vue";
import Auth from "./views/Auth.vue";
import AuthAs from "./views/AuthAs.vue";
import PasswordRecovery from "./views/PasswordRecovery.vue";
import Register from "./views/Register.vue";

Vue.use(Router);
const router = new Router({
  base: "/",
  routes:[
    {
      path: "/",
      name: "Sites",
      component: Sites,
    },
    {
      path: "/payments/:site_id/:payment_status?",
      name: "Payments",
      component: PaymentsOnlyMonth,
    },
    {
      path: "/catalogs_groups/:site_id",
      name: "Catalogs_groups",
      component: Catalogs_groups,
    },
    {
      path: "/auth",
      name: "Auth",
      component: Auth,
      beforeEnter: (to, from, next) => {
        store.getters["auth/authenticated"] === true ? next("/") : next();
      },
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      beforeEnter: (to, from, next) => {
        store.getters["auth/authenticated"] === true ? next("/") : next();
      },
    },
    {
      path: "/as/:client_id",
      name: "AuthAs",
      component: AuthAs,
    },
    {
      path: "/password-recovery",
      name: "PasswordRecovery",
      component: PasswordRecovery,
      beforeEnter: (to, from, next) => {
        store.getters["auth/authenticated"] === true ? next("/") : next();
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  let allowed = ['Auth', 'PasswordRecovery', 'AuthAs', 'Register']
  //if (to.name != "Auth" && to.name != "PasswordRecovery" && to.name != "AuthAs") {
  if (!allowed.includes(to.name)) {

    store
        .dispatch("auth/check")
        .then((isAuthorized) => {
          return isAuthorized
              ? next()
              : next("/auth");
        })
        .catch(() => {
          //console.log(e)
        });
  } else {
    next();
  }
});

export default router;
